import { formatDateTime } from "utils";

export const formatTimesheetApprovalStatus = (timesheet) => {
	if (!timesheet?.isApproved) return "pending";

	const name = String(timesheet.approvedByName || "").trim();
	const when = timesheet.approvedAtUtc ? formatDateTime(timesheet.approvedAtUtc) : "";
	const hasWhen = Boolean(when && when !== "-");

	if (name && hasWhen) return `Approved by ${name}, ${when}`;
	if (name) return `Approved by ${name}`;
	if (hasWhen) return `Approved, ${when}`;
	return "Approved";
};
